import React from 'react';
interface FAQItemProps {
	question: string;
	answer: string;
	visible: boolean;
	toggleVisibility: () => void;
}

const FAQItem: React.FC<FAQItemProps> = ({ question, answer, visible, toggleVisibility }) => {
	return (
		<div className={`${visible ? 'bg-[#97EEFF] rounded-lg mb-2' : 'border-b border-[#97EEFF]'} p-2 last:border-0`}>
			<div className="text-[#1f1f1f] flex gap-2 justify-between items-center cursor-pointer" onClick={toggleVisibility}>
				<div className="text-xs leading-[18px] font-semibold">{question}</div>
				<div className="w-6 h-6 flex justify-center items-center">
					{visible ? (
						<span className="w-6 h-6 bg-[#7EDEF1] rounded-full flex items-center justify-center cursor-pointer">
							<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-4">
								<path strokeLinecap="round" strokeLinejoin="round" d="M5 12h14" />
							</svg>
						</span>
					) : (
						<span className="w-6 h-6 bg-[#97EEFF] rounded-full flex items-center justify-center cursor-pointer">
							<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-4">
								<path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
							</svg>
						</span>
					)}
				</div>
			</div>
			{visible && <div className="text-black text-xs leading-[18px] pt-2">{answer}</div>}
		</div>
	);
};

export default FAQItem;
